export default class Cards {
    constructor() {
        this.section = document.querySelector('.modulo-cards');
        this.cards = this.section ? [...this.section.querySelectorAll('.js-stack-cards__item')] : [];

        this.modal = document.querySelector('#modal-video'); // modal global
        this.closeBtn = this.modal.querySelector('.btnCloseModal'); // botão de fechar

        // this.ready();
        this.modalVideo();
    }

    ready() {
        if (!this.cards.length) return;

        window.addEventListener('scroll', () => this.onScroll());
        this.onScroll(); // inicializa no carregamento
    }

    onScroll() {
        this.cards.forEach(card => {
            const rect = card.getBoundingClientRect();
            const stickyTop = parseInt(getComputedStyle(card).top) || 0;

            // calcula quanto o card passou do seu sticky top
            const distance = stickyTop - rect.top;

            if (distance > 0) {
                // distance varia de 0 até stickyTop
                const progress = Math.min(distance / stickyTop, 1); // 0 -> 1
                const scale = 1 - 0.2 * progress; // 1 -> 0.8
                card.style.transform = `scale(${scale})`;
            } else {
                card.style.transform = 'scale(1)';
            }
        });
    }

    modalVideo() {
        this.cards.forEach(card => {
            const buttonVideo = card.querySelector('.btnActiveVideo');
            if (!buttonVideo) return;
            buttonVideo.addEventListener('click', (e) => {
                e.preventDefault();
                
                const tipo = buttonVideo.dataset.tipo;
                const videoData = buttonVideo.dataset.video; // pode ser URL ou ID
                const content = this.modal.querySelector('.content');

                // limpa conteúdo anterior
                content.innerHTML = '';

                let html = '';

                if (tipo === 'video') {
                    html = `
                        <video autoplay controls muted playsinline loop class="block w-full h-full object-cover">
                            <source src="${videoData}" type="video/mp4">
                            Seu navegador não suporta o elemento de vídeo.
                        </video>
                    `;
                }

                if (tipo === 'youtube') {
                    html = `
                        <iframe 
                            class="aspect-video w-full relative z-0"
                            src="https://www.youtube.com/embed/${videoData}?controls=1&showinfo=0&rel=0&autoplay=0&playlist=${videoData}"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                        ></iframe>
                    `;
                }

                content.innerHTML = html;

                // abre o modal
                this.modal.classList.add('open');
            });

        });
    }
}

// Inicializa
if (document.querySelector('.modulo-cards')) {
    new Cards();
}
